import { Button } from "$components/button/button";
import { CardColors } from "$components/card";
import { SmartRecommendationIcon } from "$components/icons";
import {
  CardHeader,
  PatientHistoryCard,
} from "$routes/patient/_lib/history-card";
import { Box, styled, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import type { ReactNode } from "react";
import { BinButton } from "./bin-button";

export interface RecommendedInvestigation {
  catalogueItemLoincCode: string;
  displayName: string;
  code: string;
}

const ActionButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

const TitleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
}));

const ChildrenContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  width: "100%",
}));

export const AddInvestigationCard: FCwC<{
  children: ReactNode;
  recommendedInvestigations: RecommendedInvestigation[];
  hasSelectedInvestigation: boolean;
  onRecommendedClick: (investigation: RecommendedInvestigation) => void;
  onDelete: () => void;
}> = ({
  children,
  hasSelectedInvestigation,
  recommendedInvestigations,
  onRecommendedClick,
  onDelete,
}) => {
  return (
    <PatientHistoryCard
      color={CardColors.INVESTIGATION}
      expanded
      HeaderComponent={() => (
        <CardHeader
          color={CardColors.INVESTIGATION}
          title="Investigation"
          category=""
          extras={
            <BinButton aria-label="delete-investigation" onClick={onDelete} />
          }
        />
      )}
    >
      <ChildrenContainer>
        {children}
        {recommendedInvestigations?.length > 0 && !hasSelectedInvestigation && (
          <ActionButtonsContainer>
            {recommendedInvestigations.map((investigation) => (
              <Button
                key={investigation.catalogueItemLoincCode}
                variant="outlined"
                color="primary"
                data-testid={`recommended-investigation-${investigation.catalogueItemLoincCode}`}
                onClick={() => onRecommendedClick?.(investigation)}
                startIcon={<AddIcon />}
              >
                {investigation.displayName}
              </Button>
            ))}
          </ActionButtonsContainer>
        )}
        {recommendedInvestigations?.length !== 0 &&
          !hasSelectedInvestigation && (
            <TitleContainer>
              <SmartRecommendationIcon />
              <Typography variant="body1" color="textPrimary">
                Suggestions based on this patient's consultation data
              </Typography>
            </TitleContainer>
          )}
      </ChildrenContainer>
    </PatientHistoryCard>
  );
};
